"use strict";

var moduleName = "password-reset";

module.exports = function () {
	$(".jsPasswordReset").each(function () {
		if($.data(this, moduleName + "-init")) return;
		$.data(this, moduleName + "-init", true);



		//
		// Восстановление пароля. Скрываем/показываем поля формы
		//
		
		var radioEmail = $(".jsPasswordResetRadioEmail"),
			radioTel   = $(".jsPasswordResetRadioTel"),
			blockEmail = $(".jsPasswordResetEmail"),
			blockTel = $(".jsPasswordResetTel");

		$(window).on("load", function() {

			if(radioEmail.prop("checked")) {
				blockEmail.show();
				blockTel.hide();
			} else {
				blockEmail.hide();
				blockTel.show();
			}
		});

		$(".jsPasswordResetRadioEmail, .jsPasswordResetRadioTel").on("change", function() {

			if(radioEmail.prop("checked")) {
				blockEmail.show();
				blockTel.hide();
			} else {
				blockEmail.hide();
				blockTel.show();
			}
		});



	});
};


/** WEBPACK FOOTER **
 ** D:/phpstorm/szar/src/js/modules/passwordResetInit.js
 **/